import type { ReactNode } from 'react';
import { Box } from '@spark-web/box';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type StatusMessageProps = {
  icon: ReactNode;
  title: ReactNode;
  message: ReactNode;
};

// Centered icon + heading + message layout shared by terminal-status screens
// (quote status, withdrawn application, etc.).
function StatusMessage({ icon, title, message }: StatusMessageProps) {
  return (
    <Stack align="center" gap="xxlarge">
      {icon}
      <Heading level="1" align="center">
        {title}
      </Heading>
      <Box as="div" margin="xlarge" gap="large">
        <Text align="center" size="large" tone="muted">
          {message}
        </Text>
      </Box>
    </Stack>
  );
}

export default StatusMessage;
